export const FOOTER_SOCIAL_CONTENT = {
  heading: 'Community And Updates'
};

export const FOOTER_APP_DOWNLOAD_CONTENT = {
  heading: 'Book Faster On Mobile',
  stores: [
    {
      id: 'ios',
      icon: '📱',
      eyebrow: 'Download on the',
      label: 'App Store'
    },
    {
      id: 'android',
      icon: '🤖',
      eyebrow: 'Get it on',
      label: 'Google Play'
    }
  ]
};
